import React, { useMemo } from "react";
import { GiftingCartError, GIFTING_CART_ERROR_TYPE, useEffectOnce } from "@swiggy-private/core-ui";
import { IFullWidthButtonVariant } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton/types";

export const TooManyRequestsError = ({ nrEventHandler }: { nrEventHandler?: (screenType: string) => void }) => {
    const primaryAction = useMemo(() => {
        return {
            variant: "tertiary" as IFullWidthButtonVariant,
            onClick: () => {
                window.location.reload();
            },
            text: "Retry",
        };
    }, []);

    useEffectOnce(() => {
        nrEventHandler?.(GIFTING_CART_ERROR_TYPE.TOO_MANY_REQUESTS);
    });

    return <GiftingCartError primaryAction={primaryAction} />;
};
